import { Utils } from "../../shared/utils";

export class ContactConst {
    public static headerTable = [
        {
            field: 'isClient', title: 'Tipo', cell: (row) =>
                row.isClient && row.isProvider ? 'Cliente - Proveedor/Acreedor' : row.isClient && !row.isProvider ? 'Cliente' : !row.isClient && row.isProvider ? 'Proveedor/Acreedor' : ''
            , class: (row) => ``
        },
        { field: 'name', title: 'Razón social', cell: (row) => `${row.name}`, class: (row) => `` },
        {
            field: 'vatNumber', title: 'CIF/NIF', cell: (row) =>
                row.vatNumber === '0000000' ? `` : `${row.vatNumber}`, class: (row) => ``
        },
        {
            field: 'entranceAccountClient', title: 'Cuenta contable Cliente', cell: (row) => Utils.IsNullOrEmpty(row.accountNumberClient) ? '' : `${row.accountNumberClient}`
            , class: (row) => ``
        },
        {
            field: 'entranceAccountProvider', title: 'Cuenta contable Proveedor/Acreedor', cell: (row) =>
                Utils.IsNullOrEmpty(row.accountNumberProvider) ? '' : `${row.accountNumberProvider}`
            , class: (row) => ``
        },

        { field: 'phone', title: 'Teléfono', cell: (row) => row.phone ? `${row.phone}` : ``, class: (row) => `` },
        {
            field: 'inConvfact', title: 'Tiene Handly', cell: (row) => '●'
            , class: (row) => row.inConvfact ? `cf-dot cf-dot--green` : `cf-dot cf-dot--red`
        },
        {
            field: 'isDirect', title: 'Conexión directa', cell: (row) => '●'
            , class: (row) => row.isDirect ? `cf-dot cf-dot--green` : `cf-dot cf-dot--red`
        }
    ];
}

export class ContactBankAccountConst {
    public static headerTable = [
        { field: 'iban', title: 'IBAN', cell: (row) => `${row.iban}`, class: (row) => `` },
        { field: 'bank', title: 'Entidad', cell: (row) => `${row.bank}`, class: (row) => `` },
        { field: 'remesa', title: 'Domiciliación bancaria', cell: (row) => row.remesa ? '✓' : '', class: (row) => `` }
    ];
}

export class ContactTClientConst {
    public static headerTable = [
        { field: 'invoiceNumber', title: 'Gasto', cell: (row) => row.invoiceNumber != null ? `${row.invoiceNumber}` : '', class: (row) => `` },
        { field: 'receiverName', title: 'Destinatario', cell: (row) => `${row.receiverName}`, class: (row) => `` },
        { field: 'invoiceRelease', title: 'Fecha', cell: (row) => `${new Date(row.invoiceRelease).toLocaleDateString()}`, class: (row) => `` },
        { field: 'total', title: 'Total', cell: (row) => Utils.FormatMoney(row.total) + ' €', class: (row) => row.paided ? `paid` : `notPaid` },
        { field: 'totalPaided', title: 'Cobrado', cell: (row) => Utils.FormatMoney(row.totalPaided) + ' €', class: (row) => `paid` },
    ];
}

export class ContactTProviderConst {
    public static headerTable = [
        { field: 'invoiceNumber', title: 'Factura', cell: (row) => row.invoiceNumber != null ? `${row.invoiceNumber}` : '', class: (row) => `` },
        { field: 'issuerName', title: 'Emisor', cell: (row) => `${row.issuerName}`, class: (row) => `` },
        { field: 'invoiceRelease', title: 'Fecha', cell: (row) => `${new Date(row.invoiceRelease).toLocaleDateString()}`, class: (row) => `` },
        { field: 'total', title: 'Total', cell: (row) => Utils.FormatMoney(row.total) + ' €', class: (row) => row.paided ? `paid` : `notPaid` },
        { field: 'totalPaided', title: 'Pagado', cell: (row) => Utils.FormatMoney(row.totalPaided) + ' €', class: (row) => `paid` },
    ];
}

export class ContactImport {
    public static headerTable = [
        { field: 'companyName', title: 'Nombre/Razón Social', cell: (row) => `${row.companyName}`, class: (row) => `` },
        { field: 'vatNumber', title: 'DNI/CIF', cell: (row) => `${row.vatNumber}`, class: (row) => `` },
        { field: 'email', title: 'Email', cell: (row) => row.email ? `${row.email}` : ``, class: (row) => `` },
        { field: 'contactPerson', title: 'Persona de contacto', cell: (row) => row.contactPerson ? `${row.contactPerson}` : ``, class: (row) => `` },
        { field: 'phone', title: 'Teléfono', cell: (row) => row.phone ? `${row.phone}` : ``, class: (row) => `` },

        { field: 'isClient', title: 'Cliente', cell: (row) => row.isClient ? `${row.isClient}` : ``, class: (row) => `` },
        { field: 'isProvider', title: 'Proveedor', cell: (row) => row.isProvider ? `${row.isProvider}` : ``, class: (row) => `` },

        { field: 'isJuridical', title: 'Persona jurídica', cell: (row) => row.isJuridical ? `${row.isJuridical}` : ``, class: (row) => `` },
        { field: 'isPhysical', title: 'Persona física', cell: (row) => row.isPhysical ? `${row.isPhysical}` : ``, class: (row) => `` },
        { field: 'isPublicAdmin', title: 'Administración pública', cell: (row) => row.isPublicAdmin ? `${row.isPublicAdmin}` : ``, class: (row) => `` },


        { field: 'address', title: 'Dirección', cell: (row) => row.address ? `${row.address}` : ``, class: (row) => `` },
        { field: 'location', title: 'Localidad', cell: (row) => row.location ? `${row.location}` : ``, class: (row) => `` },
        { field: 'postalCode', title: 'Código postal', cell: (row) => row.postalCode ? `${row.postalCode}` : ``, class: (row) => `` },
        { field: 'state', title: 'Provincia', cell: (row) => row.state ? `${row.state}` : ``, class: (row) => `` },
        { field: 'country', title: 'País', cell: (row) => row.country ? `${row.country}` : ``, class: (row) => `` },

        { field: 'entranceAccount', title: 'Cuenta contable de ingreso', cell: (row) => row.entranceAccount ? `${row.entranceAccount}` : ``, class: (row) => `` },
        { field: 'expenseAccountProvider', title: 'Cuenta contable de gasto', cell: (row) => row.expenseAccountProvider ? `${row.expenseAccountProvider}` : ``, class: (row) => `` },

    ];
}

export class CenterConst {
    public static headerTable = [
        { field: 'name', title: 'Nombre', cell: (row) => `${row.name}`, class: (row) => `` },
        { field: 'code', title: 'Código', cell: (row) => row.code ? `${row.code}` : ``, class: (row) => `` },
        { field: 'phone', title: 'Teléfono', cell: (row) => row.phone ? `${row.phone}` : ``, class: (row) => `` },
        { field: 'email', title: 'Email', cell: (row) => row.email ? `${row.email}` : ``, class: (row) => `` }
    ];
}

export class ContactPropertyConst {
    public static headerTable = [
        { field: 'address', title: 'Dirección', cell: (row) => `${row.address}`, class: (row) => `` },
        { field: 'postalCode', title: 'Código postal', cell: (row) => `${row.postalCode}`, class: (row) => `` },
        { field: 'cadastralReference', title: 'Referencia catastral', cell: (row) => `${row.cadastralReference}`, class: (row) => `` },
        { field: 'provinceCode', title: 'Código provincia', cell: (row) => `${row.provinceCode}`, class: (row) => `` },
        { field: 'municipalityCode', title: 'Código municipio', cell: (row) => `${row.municipalityCode}`, class: (row) => `` },
    ];
}
